/** 商品SKU管理API */
import type { Api } from '@/typings/api';
import { download, post, upload } from '../../request';
const prefix = '/base/productSku';
/**
 * 分页查询商品SKU管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.ProductSku> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询商品SKU管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.ProductSku> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个商品SKU管理
 *
 * @param id 商品SKU管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.ProductSku> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存商品SKU管理
 *
 * @param params 商品SKU管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新商品SKU管理信息
 *
 * @param params 商品SKU管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除商品SKU管理
 *
 * @param id 商品SKU管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除商品SKU管理
 *
 * @param ids 商品SKU管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导入
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/import`, file, params);
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  doImport,
  doExport
};
